var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"fr"},[_vm._t("left"),_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._t("right"),_vm._t("rightIcons")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }